import { render, staticRenderFns } from "./LocaleSwitch.vue?vue&type=template&id=b564b610&scoped=true"
import script from "./LocaleSwitch.vue?vue&type=script&lang=js"
export * from "./LocaleSwitch.vue?vue&type=script&lang=js"
import style0 from "./LocaleSwitch.vue?vue&type=style&index=0&id=b564b610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b564b610",
  null
  
)

export default component.exports